import React, { Component, useEffect } from 'react';
import { Field } from 'react-final-form';
import { area } from '@turf/area';

export function getAcres(value) {
  if (!value) {
    return '';
  }
  const numAcres = area(value) / 4046.86;
  return numAcres < 0.995 ? `${numAcres.toFixed(2)} acres` :
    numAcres < 9.95 ? `${numAcres.toFixed(1)} acres` :
      `${Math.round(numAcres)} acres`;
}

const FieldPolygonsInputComponent = ({ origin, input: { onChange, value } }) => {
  const [mapElement, setMapElement] = React.useState(null);

  const mapCallback = mapElement => setMapElement(mapElement);
  useEffect(() => {
    if (mapElement) {
      const map = new window.mapboxgl.Map({
        container: mapElement,
        style:     'mapbox://styles/mapbox/satellite-streets-v11',
        center:    [origin.lng, origin.lat],
        zoom:      11,
      });

      const Draw = new window.MapboxDraw({
        displayControlsDefault: false,
        controls:               {
          polygon: true,
          trash:   true,
        },
      });

      // Map#addControl takes an optional second argument to set the position of the control.
      // If no position is specified the control defaults to `top-right`. See the docs
      // for more details: https://docs.mapbox.com/mapbox-gl-js/api/#map#addcontrol

      map.addControl(Draw, 'top-left');

      map.on('load', function() {
        value && Draw.add(value);
        Draw.changeMode('draw_polygon');
        map.on('draw.create', onDrawChange);
        map.on('draw.delete', onDrawChange);
        map.on('draw.update', onDrawChange);

        function onDrawChange() {
          const areas = Draw.getAll();
          onChange(areas.features.length ? areas : null);
        }
      });

      return () => {
        map.remove();
      };
    }
  }, [mapElement]);

  return <div>
    <div style={{ position: 'relative', padding: '50%' }}>
      <div ref={mapCallback} style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 }} />
    </div>
    {getAcres(value)}
  </div>
};

class FieldPolygonsInput extends Component {
  componentWillUnmount() {
    // Unmounting happens too late if it is done inside Field component
    // (Then Form has already registered its (new) fields and
    // changing the value without corresponding field is prohibited in Final Form
    if (this.props.onUnmount) {
      this.props.onUnmount();
    }
  }

  render() {
    return <Field component={FieldPolygonsInputComponent} {...this.props} />;
  }
}

export default FieldPolygonsInput;
